<template>
  <div class="default-dashboard full-height">
    <transition class="full-height">
      <keep-alive :include="$route.meta.include">
        <router-view />
      </keep-alive>
    </transition>

    <van-tabbar safe-area-inset-bottom v-if="isYlslh5">
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <van-col
          v-for="(tab,index) in tabbarList"
          :key="tab.link"
          :span="tabbarList.length == 3 ? 8 : 12"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>

    <van-tabbar class="shadow" v-if="!isXlminiprogram && !isYlslh5">
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <van-col
          v-for="(tab,index) in tabbarList"
          :key="tab.link"
          :span="(tabbarList.length == 4 ? 6 : ((tabbarList.length == 5 && index == 2) ? 4 : 5))"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>
  </div>
</template>

<script>
import home from 'Components/Dynamic/default/images/navbar/home.png'
import home1 from 'Components/Dynamic/default/images/navbar/home1.png'
import user from 'Components/Dynamic/default/images/navbar/user.png'
import user1 from 'Components/Dynamic/default/images/navbar/user1.png'
import approval from 'Components/Dynamic/default/images/navbar/approval.png'
import approval1 from 'Components/Dynamic/default/images/navbar/approval1.png'
import triplist from 'Components/Dynamic/default/images/navbar/triplist.png'
import message from 'Components/Dynamic/default/images/navbar/message.png'
import message1 from 'Components/Dynamic/default/images/navbar/message1.png'
import count from 'Components/Dynamic/default/images/navbar/count.png'
import count1 from 'Components/Dynamic/default/images/navbar/count1.png'
import allorders from 'Components/Dynamic/default/images/navbar/allorder.png'
import allorders1 from 'Components/Dynamic/default/images/navbar/allorder1.png'


import tab1 from 'Components/Dynamic/kh/images/home/tab1.png'
import tab2 from 'Components/Dynamic/kh/images/home/tab2.png'
import tab3 from 'Components/Dynamic/kh/images/home/tab3.png'
import tab4 from 'Components/Dynamic/kh/images/home/tab4.png'
import tab5 from 'Components/Dynamic/kh/images/home/tab5.png'

import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'
import { Image as VanImage, Badge ,Tabbar} from 'vant'
import defaultMixin from '../../../mixins/default'

export default {
  name: 'Dashboard',
  mixins:[defaultMixin],
  components:{
    [VanImage.name]: VanImage,
    [Badge.name]: Badge,
    [Tabbar.name]: Tabbar,
  },
  data () {
    return {
      hashAddr: '/home'
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      badgeDotCount: 'badgeDotCount'
    }),
    tabbarList() {
      let obj = []
      if (this.isYlslh5){
        obj=[
          {
            link: '/tk/tkQuery',
            count:'',
            normalImg: tab1,
            activeImg: tab1
          },
          {
            link: '/statistical',
            count: '',
            normalImg: tab2,
            activeImg: tab2
          },
          {
            link: '/allorder',
            otherLink:'/allOrder',
            count:'',
            normalImg: tab3,
            activeImg: tab3,
          }
        ]
        if (!(this.userInfo.empInfo.travelStats && this.userInfo.empInfo.travelStats == 1)){
          obj.splice(1,1);
        }
        return obj
      }else {
        obj=[
          {
            link: '/home',
            count:'',
            normalImg: tab1,
            activeImg: tab1
          },
          {
            link: '/userCenter/message', //message
            otherLink: '/noticeList',
            count: this.badgeDotCount ? this.badgeDotCount.message:'',
            normalImg: tab2,
            activeImg: tab2
          },
          {
            link: '/tripList',
            count:'',
            normalImg: tab3,
            activeImg: tab3
          },
          {
            link: '/approvalList',
            count: this.badgeDotCount ? this.badgeDotCount.daibantotal:'',
            normalImg: tab4,
            activeImg: tab4
          },
          {
            link: '/khuserCenter',
            count:'',
            normalImg: tab5,
            activeImg: tab5
          }
        ]
      }

      if(this.userInfo.vipCorp){
        if(this.userInfo.vipCorp.bookStyle==1){
          obj.splice(2,1)
          return obj
        }
      }else{
        let userInfo = localget('userInfo')
        if(userInfo){
          this.$store.commit('SET_USERINFO',userInfo)
          //如果是单订模式 删除申请单的入口
          if(userInfo.vipCorp&&userInfo.vipCorp.bookStyle==1){
            obj.splice(2,1)
            return obj
          }
        }
      }
      return obj
    }
  },
  created () {
    this.hashAddr = this.$route.path
  },
  watch: {
    '$route.path': function (val) {
      if(val === '/allorder'){//默认进入订单列表中的 未出行
        this.$store.commit('SET_ORDERLISTPARAMS', { findType: '3' })
      }
      this.hashAddr = val
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.default-dashboard {
  .nav-tabbar {
    background-color: #EEEEF6;
    // position: fixed;
    // left: 0px;
    // bottom: 0px;
    // right: 0px;
    width: 100%;
    height: 50px;
    // border-radius: @border-radius-sm;
    overflow: hidden;
    text-align: center;
    padding: 4px 0;
    line-height: 1;

    .normal {
      height: 26px;
    }

    .active {
      height: 26px;
    }

    @{deep}.van-badge--fixed {
      top: 6px;
    }
  }

}
</style>
